import { Button, Typography } from 'antd';

import type { NSocialIntegrations } from '@app/services/rtkQuery/SocialIntegrations/types';
import { IntegrationStatus } from '@app/shared/ui/IntegrationStatus';
import { SocialIntegrationIcon } from '@app/shared/ui/SocialIntegrationIcon';

import type { ColumnsType } from 'antd/es/table';

interface GetSocialIntegrationsColumnsProps {
  openIntegration: (id: SocialIntegrationErrorItem) => void;
}

type SocialIntegrationErrorItem =
  NSocialIntegrations.ModelSocialIntegrationError;

type GetSocialIntegrationsColumnsType = (
  props: GetSocialIntegrationsColumnsProps
) => ColumnsType<SocialIntegrationErrorItem>;

const { Text } = Typography;

export const getSocialIntegrationsColumns: GetSocialIntegrationsColumnsType = ({
  openIntegration,
}) => {
  const columns: ColumnsType<SocialIntegrationErrorItem> = [
    {
      title: '',
      key: 'SocialType',
      dataIndex: 'SocialType',
      render: (
        socialType: NSocialIntegrations.SocialIntegrationType | null
      ) => <SocialIntegrationIcon type={socialType} size="md" />,
      // Ширина обязательна: у остальных колонок она задана, и без неё antd
      // отдаёт колонке с иконкой весь свободный остаток — иконка прижимается
      // влево, а название интеграции переносится по словам.
      width: 56,
    },
    {
      title: 'Интеграция',
      key: 'IntegrationName',
      dataIndex: 'IntegrationName',
      render: (name?: string | null) => <Text strong>{name}</Text>,
    },
    {
      title: 'Филиал',
      dataIndex: 'BranchName',
      key: 'BranchName',
      render: (name?: string | null) => <Text strong>{name}</Text>,
      width: 220,
    },
    {
      title: 'Статус',
      key: 'Status',
      dataIndex: 'Status',
      render: (
        status: NSocialIntegrations.SocialIntegrationChannelStatus,
        record: SocialIntegrationErrorItem
      ) => (
        // Тот же компонент и словарь, что в реестре интеграций и карточках
        // пользователя: до этого у баннера были свои слова и свой словарь
        // подстатусов (issue/11019, issue/11031).
        <IntegrationStatus
          status={status ?? null}
          subStatus={record.SubStatus}
        />
      ),
      width: 230,
    },
    {
      title: '',
      key: 'actions',
      width: 120,
      align: 'right' as const,
      render: (_: unknown, item: SocialIntegrationErrorItem) => (
        <Button
          type="primary"
          onClick={() => openIntegration(item)}
          disabled={!item.CanUserOpen}
        >
          Открыть
        </Button>
      ),
    },
  ];

  return columns;
};
